export default {
    id: 'orange-gray-blue',
    colors: ['#FF9580', '#D8D8D8', '#8CCBFF'],
};
